import { useContext } from 'react'
import { I18nContext } from './I18nContext'
import { readPreferredLanguage } from './languageResources'

/** Also works in the outer crash boundary, before providers have mounted. */
export function useInterfaceLanguage() {
    const context = useContext(I18nContext)
    const documentLanguage = typeof document === 'undefined' ? '' : document.documentElement.lang
    return context?.language ?? readPreferredLanguage(documentLanguage === 'ha' || documentLanguage === 'ar'
        ? documentLanguage : 'en')
}
